export enum FilterType {
  INCLUDE = 'INCLUDE',
  EXCLUDE = 'EXCLUDE',
}
